import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';

export const useAmount = (carId) => {
   const api = "" 
   //useEffect(() => {
   // fetchAmounts(carId, typeId);
   //}, []);

   const fetchAmounts = () => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
      };
  
      automobyApi
        .post("/amount/list", requestData)
        .then(response => {
          resolve(response.data.amounts);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

 
  
  const addAmountContainer = (newAmount) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/amount/container/add", newAmount)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };


  const addAmountCargo = (newAmount) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/amount/cargo/add", newAmount)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };



  const addAmountSource = (newAmount) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/amount/source/add", newAmount)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };


  const removeAmount = (amountId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        amount_id: amountId
      };
  
      automobyApi
        .post("/amount/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetchByContainerId = (containerId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        container_id: containerId,
      };
  
      automobyApi
        .post("/amount/container/list", requestData)
        .then(response => {
          resolve(response.data.amounts);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const fetchByCargoId = (cargoId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        cargo_id: cargoId,
      };
  
      automobyApi
        .post("/amount/cargo/list", requestData)
        .then(response => {
          resolve(response.data.amounts);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
 
   
  const amountService = {
    fetchAmounts: fetchAmounts,
    addAmountContainer: addAmountContainer,
    addAmountCargo: addAmountCargo,

    removeAmount: removeAmount, 
    fetchByContainerId:fetchByContainerId,
    fetchByCargoId:fetchByCargoId,

   };

  return { amountService };
 
}